require("@root/node_modules/angular/angular-csp.css");
require('@root/node_modules/ui-select/dist/select.css');

import angular from 'angular';
import uiSelect from 'ui-select';

import payseraHttp from '@root/assets/js/module/paysera-http/app';

import appRun from './app.run';
import currencyExchangeDirective from './directive/module.js';
import currencyExchangeService from './service/module.js';
import currencyExchangeFilter from './filter/module.js';

angular
    .module('paysera.currency_exchange_table', [
        uiSelect,
        payseraHttp,
        currencyExchangeDirective,
        currencyExchangeService,
        currencyExchangeFilter
    ])
    .constant(
        'PROVIDERS', {
            'COMMERCIAL': 'commercial',
            'OFFICIAL': 'official-by-partner'
        }
    )
    .run(appRun)
;

export default angular.module('paysera.currency_exchange_table').name;
